import { makeStyles } from "@mui/styles"
import { colors } from "../../utils"
import { images } from "../../utils"

const useStyles = makeStyles((theme) => ({
  title: {
    "&.MuiTypography-root": {
      fontWeight: "bold",
      fontSize: "1.4rem",
      color: colors.primary,
      textAlign: "left",
      [theme.breakpoints.up("xxl")]: {
        "&.MuiTypography-root": {
          fontSize: "1.6rem",
        },
      },
    },
  },

  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  bg: {
    backgroundImage: `url(${images.homeImg})`,
    backgroundRepeat: "no-repeat",
    right: "0",
    bottom: "0",
    width: "70%",
    height: "75%",
    position: "absolute",
    zIndex: "-1",
    backgroundSize: "cover",
    [theme.breakpoints.down("lg")]: {
      display: "none",
    },
    [theme.breakpoints.up("xxl")]: {
      width: "60%",
      bottom: "34px",
      height: "70%",
    },
  },

  body: {
    width: "90%",
    margin: "36px auto 70px auto",
    [theme.breakpoints.up("xxl")]: {
      width: "60%",
      margin: "4%",
      marginRight: "0",
      marginBottom: "0",
    },
  },

  parraf: {
    "&.MuiTypography-root": {
      marginTop: "30px",
      color: colors.greyStrong,
      textAlign: "left",
      fontSize: "1.2rem",
    },
    [theme.breakpoints.up("xxl")]: {
      "&.MuiTypography-root": {
        fontSize: "1.4rem",
      },
    },
  },

  docs: {
    display: "flex",
    flexDirection: "row",
    marginTop: "30px",
  },

  select: {
    width: "100%",
  },

  input: {
    width: "100%",
  },

  bodyParraf: {
    width: "90%",
    margin: "0 auto",
    [theme.breakpoints.up("md")]: {
      margin: "0",
    },
  },

  bodyHeadTitle: {
    width: "90%",
    margin: "0 auto",
    [theme.breakpoints.up("md")]: {
      margin: "0",
    },
  },

  bodyHead: {
    [theme.breakpoints.up("lg")]: {
      width: "70%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "50%",
    },
    [theme.breakpoints.up("xxl")]: {
      width: "100%",
    },
  },

  buttonContainer: {
    margin: "35px auto 0 auto",
    width: "90%",
    fontWeight: "bold",
    [theme.breakpoints.up("md")]: {
      width: "50%",
      margin: "35px 0 0 0",
      "&.MuiButton-root": {
        fontSize: "1.4rem",
      },
    },
    [theme.breakpoints.up("xl")]: {
      width: "30%",
    },
  },

  button: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      "&.MuiButton-root": {
        fontSize: "1.1rem",
      },
    },
  },

  boxs: {
    display: "flex",
    flexDirection: "column",
    margin: "25px auto 0 auto",
    width: "90%",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      margin: "35px 0 0 0",
    },
    [theme.breakpoints.up("xl")]: {
      width: "70%",
    },
  },
  documentTypeContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.up("md")]: {
      width: "48%",
    },
  },

  documentNumContainer: {
    margin: "25px 0 0 0",
    width: "100%",
    position: "relative",
    [theme.breakpoints.up("md")]: {
      width: "48%",
      margin: "0 0 0 25px",
    },
  },

  errorContainer: {
    position: "absolute",
    top: "48px",
    left: "5px",
    // [theme.breakpoints.down("xl")]: {
    // 	top: "48px",
    // },
  },
}))

export default useStyles
